import instance from '../api/instance';
import { logout } from "./sessionActions";

import { GET_COUNTRIES } from '../constants/constants';

export const getCountries = () => {
    return dispatch => {
        return instance.get(`/countries`)
            .then(response => {
                dispatch({
                    type: GET_COUNTRIES,
                    countries: response.data.data
                })
            }).catch(err => {
                var statusCode = err.response.status;

                switch (statusCode) {
                    case 401: // Deslogueamos porque el token es inválido
                        dispatch(logout());
                        break;
                    case 500: // Deslogueamos porque el token es inválido
                        dispatch(logout());
                        break;
                }
            })
    }
}